import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

export const Lines = props => {
    useStyles(classes)
    return <div className={classes.Lines}>{props.children}</div>
}

export default props => {
    useStyles(classes)
    return <div className={classes.Container}>
        <div className={classes.Title}>
            {props.title}
        </div>
        {props.children}
    </div>
}